import { Typography } from '@mui/material'

const HelpText = () => {

  return (
    <div className='p-5'>
      <Typography variant='h5' className='pb-5'>Credit Plan</Typography>


    </div>
  )
}

export default HelpText